export const ERROR_TITLES = {
  password: {
    request: 'Unable to send password reset instructions',
    update: 'Unable to reset password',
  },
  session: {
    create: 'Unable to log in',
  },
  unlock: {
    request: 'Unable to send unlock instructions',
    confirm: 'Unable to unlock user',
  },
  user: {
    create: 'Unable to create an account',
  },
};

export const SUCCESS_MESSAGES = {
  password: {
    request: {
      title: 'Password reset instructions sent',
      description: 'Check your email for password reset instructions.',
    },
    update: {
      title: 'Password reset successful',
      description: 'Log in with your new password.',
    },
  },
  unlock: {
    request: {
      title: 'Unlock instructions sent',
      description: 'Check your email for unlock instructions.',
    },
    confirm: {
      title: 'User unlocked',
      description: 'Log in to continue.',
    },
  },
};
